module.exports = __webpack_public_path__ + "img/izzyedu.212fc644.png";